<template>
  <!-- 第二板块 积分榜-->
  <h3
    style="
      font-weight: normal;
      padding-left: 10px;
      color: #e84b5b;
      padding: 10px;
      font-size: 16px;
      font-weight: 600;
    "
  >
    积分榜
  </h3>
  <div class="league_s">
    <el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick">
      <el-tab-pane label="英超" name="36"></el-tab-pane>
      <el-tab-pane label="德甲" name="8"></el-tab-pane>
      <el-tab-pane label="西甲" name="31"></el-tab-pane>
      <el-tab-pane label="法甲" name="11"></el-tab-pane>
      <el-tab-pane label="意甲" name="34"></el-tab-pane>
    </el-tabs>

    <el-table :data="leagueList" size="mini">
      <el-table-column prop="rank" label="排名" align="center" width="40">
        <template v-slot="scope">
          <div :style="{ background: color_obj[scope.row.rank] }">
            {{ scope.row.rank }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="teamName" label="球队" align="center" width="">
        <template v-slot="scope">
          <router-link
            target="_blank"
            :to="{
              path: `/soccer/team/${scope.row.team_id}/lineup`
            }"
            >{{ scope.row.team_name }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="win_score"
        align="center"
        width="60"
        label="胜/平/负"
      >
        <template v-slot="scope">
          <div>
            {{ scope.row.win_score }}/{{ scope.row.flat_score }}/{{
              scope.row.fail_score
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="score" align="center" width="40" label="积分">
        <template v-slot="scope">
          <div style="color: #e74c5b">
            {{
              scope.row.deduct
                ? parseInt(scope.row.win_score * 3) +
                  parseInt(scope.row.flat_score) -
                  parseInt(scope.row.deduct)
                : parseInt(scope.row.win_score * 3) +
                  parseInt(scope.row.flat_score)
            }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="item_ss">
      <p v-for="(item, index) in color_data" :key="index">
        <span class="point" :style="{ background: item.color }"></span>
        <span class="text">{{ item.qualify }}</span
        ><br />
      </p>
    </div>
  </div>
</template>
<script>
import { ref, getCurrentInstance } from 'vue'

export default {
  setup() {
    let { proxy: _this } = getCurrentInstance()
    let activeName = ref('36')
    let sclassInfo = async (sclassId) => {
      let { data: res } = await _this.$http.get(`soccer/sclass/${sclassId}`)
      league_score(sclassId, res.data.select_season)
    }
    sclassInfo(36)
    // 积分榜
    let leagueList = ref([])
    let color_data = ref([])
    let color_obj = ref({})
    let league_score = async (sclassId, select_season) => {
      let { data: res } = await _this.$http.get(
        `/soccer/sclass/${sclassId}/league_score`,
        {
          params: {
            match_season: select_season
          }
        }
      )
      leagueList.value = res.data.all_score
      color_data.value = res.data.color_data
      if (res.data.color_data) {
        res.data.color_data.forEach((item) => {
          for (let i = item.begin_rank; i <= item.end_rank; i++) {
            if (!(i in color_obj.value)) {
              color_obj.value[i] = item.color
            }
          }
        })
      }
      // console.log(res.data)
    }
    let handleClick = (v) => {
      sclassInfo(v.props.name)
    }
    return {
      activeName,
      handleClick,
      leagueList,
      color_data,
      color_obj
    }
  }
}
</script>

<style scoped lang="less">
.league_s {
  background: #fff;
  border-radius: 6px;
  width: 290px;
  .el-tabs {
    // width: 290px;
    margin-left: 10px;
  }

  .el-table {
    width: 280px;
    margin-left: 10px;
    margin-top: -10px;
  }

  .item_ss {
    background-color: #f7f8fa;
    padding: 20px 10px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;

    .point {
      width: 30px;
      height: 20px;
      display: inline-block;
      margin-right: 10px;
    }

    p {
      display: flex;
      align-items: center;
      margin: 6px 0;
    }
  }
}
</style>
